import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

import { LegalEntityPhase } from './LegalEntityPhase'

interface CreateModalProps {
  onClose: () => void
  onSubmit?: () => void
  backNavigation?: string
  finishNavigation?: string
}

export const CreateModal = ({
  onClose,
  onSubmit,
  backNavigation,
  finishNavigation,
}: CreateModalProps) => {
  const state = useLocation().state
  const [selectedLegalEntityId, setSelectedLegalEntityId] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [showNuvoImporter, setShowNuvoImporter] = useState(false)
  const [showLegalEntityPhase, setShowLegalEntityPhase] = useState(true)
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const handleCompleted = () => {
    onSubmit?.()
  }

  const metadata = state?.employeeIds
    ? {
        employee_ids: state.employeeIds?.map((id: string) => BigInt(id)),
        legal_entity_ids: state.legalEntityIds?.map((id: string) => BigInt(id)),
        resource_type: ['Employee'],
        active: [false],
      }
    : {
        legal_entity_ids: selectedLegalEntityId ? [BigInt(selectedLegalEntityId)] : [],
        employee_ids: [],
        resource_type: ['Employee'],
        active: [true],
      }

  return (
    <>
      {showLegalEntityPhase && !state?.employeeIds && (
        <LegalEntityPhase
          onClose={onClose}
          selectedLegalEntityId={selectedLegalEntityId}
          setSelectedLegalEntityId={setSelectedLegalEntityId}
          onSubmit={() => setShowNuvoImporter(true)}
          loading={loading}
        />
      )}

      {(showNuvoImporter || state?.employeeIds) && (
        <NuvoImporter
          importType="cost_center_assignment_importer"
          companyId={company.id}
          locale={locale}
          metadata={metadata}
          isEdition
          customLoading={<></>}
          onError={onClose}
          customBackNavigation={backNavigation}
          customFinishNavigation={finishNavigation}
          onCompleted={handleCompleted}
          onLoading={(value) => {
            setLoading(value)
            setShowLegalEntityPhase(value)
          }}
        />
      )}

      <Outlet />
    </>
  )
}
